export default "__VITE_ASSET__eVgBg6tN__"